<template>
    <section class="container-fluid header-list-type-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="wrp">
                        <div class="content">
                            <h1 class="name">{{ $t('views.audiences.title') }}</h1>
                            <p>{{ $t('views.audiences.description') }}</p>
                        </div>
                        <div class="actions" v-if="!loading && !error && audiences.length > 0">
                            <router-link class="btn-1 btn-s-icon" :to="{ name: 'companies' }">
                                <div class="icon-plus-pos"></div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudiencesStore } from '@/stores/audiences';

    export default {
        name: "AudiencesHeader",
        computed: {
            ...mapState(useAudiencesStore, ['audiences', 'loading', 'error']),
        },
    }
</script>